import pl from "@locales/online_payments/pl.json";
import en from "@locales/online_payments/en.json";

export default {
  pl: pl,
  en: en,
};
